export enum GenderEnum {
    Female = 1,
    Male = 2,
    None = 3
}
